import React from "react";
// import HttpService from '../utils/Http.services';
// import { siteConfig, siteTheme } from "../../variables/config";
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../../../stores/actionsList';
// import TabBar from "../views/TabBar";
// import Configurer from "../Configurer";
// import ProfileImage from "../components/partials/ProfileImage";
// import TableViewer from "../components/TableViewer";
import { v4 as uuidv4 } from 'uuid';
// import Collapsible from "react-collapsible";
import DiagramComponent from "../../../../components/views/diagram/DiagramComponent";
import { diagramComponents, diagramGroups } from "../../../../variables/diagramFunctions";

import { debounce, throttle } from 'throttle-debounce';

// import FormViewer from '../FormViewer'
import DiagramPath from "../../../../components/views/diagram/DiagramPath";
// import DiagramSidebar from "../../../components/views/diagram/DiagramSidebar";
import Modal from "../../../../components/Modal";
import LoaderButton from "../../../../components/LoaderButton";
import { checkTranslation, getObject, translate } from "../../../../utils/useful";
import HttpServices from "../../../../utils/Http.services";
import { getBoundingClientRect } from "../../../../utils/functions";
import DiagramComponentConfig from "../../../../components/views/diagram/DiagramComponentConfig";
import DiagramSidebar from "../../../../components/views/diagram/DiagramSidebar";
// import SearchUsersModal from "../../../../modals/SearchUsersModal";
// import SearchGroupsModal from "../../../../modals/SearchGroupsModal";
// import SidebarView from "../../../../components/SidebarView";
// import AddPermissionModal from "../../../../modals/AddPermissionModal";
// import SwitchInput from "../../../../components/inputs/SwitchInput";
import ButtonAnimated from "../../../../components/buttons/ButtonAnimated";
import DiagramTopbar from "../../../../components/views/diagram/DiagramTopbar";
import DiagramAddElement from "../../../../components/views/diagram/DiagramAddElement";
import importedIcons from "../../../../components/inputs/icons";
import FixedView from "../../../../components/FixedView";
import DiagramVariablesSidebar from "../../../../components/views/diagram/DiagramVariablesSidebar";
import { nanoid } from "nanoid";

// const 

class DiagramEditor extends React.Component {

    miniWidth = 120

    state = {
        data: {},
        components: {},
        paths: {},
        nodes: {},
        zoom: 1,
        showElements: true,
        variablesList: [],
        diagramVariables: {},
        flowName: '',
        optionsList: {
            // { key: 'variables', label: 'variables' },
            // { key: 'calculator', label: 'calculatorTET' },
            // { key: 'function-name', label: 'Function Name' },
            // { key: 'function-test', label: 'Function test' },
        }

    }

    // debounceFunc = throttle(1, false, (pathKey, as, points) => {
    debounceFunc = debounce(1, false, (paths) => {

        this.setState({ paths })
        // console.log('path====================', paths)

    });


    componentDidMount() {
        // console.log('this.props.data',this.props.data)
        this.getFlows()
        // this.fetchVariables()
        // console.log('herrrrrrrreppp')
        this.resizeListener = window.addEventListener('resize', this.updateMiniViewSize)
        setTimeout(() => {
            this.updateMiniViewSize()
        }, 10);
        // this.fetchData()
        // console.log('this.props.flowName',this.props.flowName)
        if (this.props.setHeader) {
            this.props.setHeader({
                'toolbar': null,
                'showToolbar': false,
                'title': this.props.page?.title,
                'subtitle': this.props.page?.subtitle,
                topHeaderComponent: this.topHeaderComponent,
                headerIdentityComponent: this.headerIdentityComponent,
                backAction: () => this.props.isCreateFrame ? this.props.lastStage() : this.props.changePage('')
            })
        }
        let initData = JSON.parse(JSON.stringify(this.props.initData ?? {}))
        initData?.permissions?.admins.map((admin) => {
            for (let index = admin.permissions.length - 1; index >= 0; index--) {
                if (admin.permissions[index].id == 'applet') {
                    admin.permissions.splice(index, 1)
                }
            }
        })
        this.setState({ type: this.props.data?.type, mode: this.props.data?.mode, admins: initData?.permissions?.admins, frames: initData?.frames, flowName: this.props.flowName }, () => {
            if (!initData?.permissions?.admins) {
                this.getFrameAdmins()
            }

        })

    }


    componentDidUpdate(prev) {
        if (this.props.data && (this.props.data != prev.data)) {
            this.getFlows()
        }
    }


    getFrameAdmins = () => {
        let body = { applet: this.props.variables.appletId, unify: true }
        HttpServices.request('getAppletRoles', body, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            // console.log('adminstl', fetchResult)
            this.setState({ admins: fetchResult.info })

        })
    }
    setAdmins = (admins, cb) => {

        let currentHeadersData = this.state.currentHeadersData
        // let stages = this.state.stages

        currentHeadersData.admins = admins
        // let currentStageIndex

        // stages.forEach((stage, index) => {
        //     if (stage.id == currentHeadersData.id) {
        //         currentStageIndex = index
        //     }
        // });

        // console.log("currentStageIndex",currentStageIndex)

        // if (currentStageIndex) {

        // stages[currentStageIndex] = currentHeadersData
        this.setState({ currentHeadersData })


        this.setState({ currentHeadersData }, () => {
            // console.log('admins',admins)
            // console.log(this.state.currentStage)
            if (cb) {
                cb()
            }
        })
        // }
    }
    headerIdentityComponent = () => {
        return (
            <div className='' >
                <input type="text" onChange={(e) => this.setName(e.target.value)} required={true} value={this.state.flowName} className={' ' + this.props.colors?.iconInvert ? 'lightPlaceholder' : 'darkPlaceholder'} style={{ fontSize: '18px', backgroundColor: 'transparent', border: 'none', color: this.props.colors.textColor }} placeholder={translate('Insert name ...')} />
            </div>
        )
    }
    setName = (value) => {
        this.setState({ flowName: value }, () => {
            this.props.setHeader("dummy", 1)
        })
    }
    fetchVariables = () => {
        // this.fetchTings()
        let data = {}
        data.applet = this.props.variables.appletId
        // console.log('fetchvar', data)
        // return
        HttpServices.request('getVariables', data, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            // console.log('fetchReusult', fetchResult.info)
            let optionsList = this.state.optionsList
            optionsList.variables = { list: [], sort: 1, label: 'variables', key: 'variables' }
            optionsList.collection = { list: this.props.frames, sort: 2, label: 'collection', key: 'collection' }
            this.setState({ variablesList: fetchResult.info, optionsList }, () => {
            })
        })
    }

    topHeaderComponent = () => {

        // let variables = { appletId: this.props.variables.appletId, user: this.props.user.info, headers: this.props.headers, appletHub: this.props.applet.hub }
        let variables = {
            appletId: this.props.variables.appletId,
            user: this.props.user.info,
            headers: this.props.headers,
            appletHub: this.props.applet?.hub ?? this.props.variables.appletHub,
            appletHubId: this.props.applet?.hub?._id ?? this.props.variables.appletHubId
        }

        return (
            <div className='flexc'>

                <button onClick={() => this.plusFixedView.showView()} ref={el => this.plusBut = el} className="br-30 flexcc" style={{ backgroundColor: '#fff', height: 30, width: 30 }}>
                    <img src="/assets/icons/useful/more.png" className="rorate-90" height={20} />
                </button>

                <FixedView width={this.props.width} zIndex={10} ref={el => this.plusFixedView = el} nodeRef={this.plusBut} xOffset={-7} bottomOffset={this.props.fullSize ? -7 : 0} topOffset={7} maxWidth={180} >
                    <div className='bg-white br-10 py-2 px-3 shadow-3 sc-gray2 d-flex flex-column'>


                        <button className="w-100 p-0 text-start flexc mt-1 mb-1" onClick={() => this.props.openEditModal(this.props.data)}>
                            <img src='/assets/icons/useful/star (9).png' height={15} alt='' />
                            <p className="text-smaller text-semibold px-1  ">{translate('Make as default')}</p>
                        </button>

                        <button className="w-100 p-0 text-start flexc mt-1 mb-1" onClick={() => this.props.openEditModal(this.props.data)}>
                            <img src='/assets/icons/useful/directions.png' height={15} alt='' />
                            <p className="text-smaller text-semibold px-1  ">{translate('Convert to advance')}</p>
                        </button>

                        <div className="w-100 my-2" style={{ height: 1, background: "#eee" }}>

                        </div>

                        <button className="w-100 p-0 text-start flexc mt-1 mb-2" onClick={() => { this.plusFixedView.hideView(); this.diagramVariablesSidebar.open() }}>
                            <img src='/assets/icons/useful/edit.png' height={15} alt='' />
                            <p className="text-smaller text-semibold px-1  ">{translate('Open variables')}</p>

                        </button>

                    </div>
                </FixedView>


                <div className='px-2'>
                    <DiagramAddElement setData={this.setData} variables={variables} variablesList={this.state.variablesList} showElements={this.state.showElements} width={this.props.width} onDragStart={this.onDragStart} onDrop={this.onDrop} onTouchMove={this.onTouchMove} sideOpen={true} hideOverlay={true} draggable={true} page={this.props.page} colors={this.props.colors} />
                </div>
                {/* <div className="px-2">
                    <button className={" px-3 py-2 flexc br-20 " + (this.state.showElements ? " add-element " : " add-element-selected ")} onClick={() => this.toggleShowElements()}>
                        <img width={20} src='/assets/icons/pagebuilder/plus-white.svg' />
                        <img width={20} src='/assets/icons/pagebuilder/plus-black.svg' />
                        <p className='font-size-14 black weight-500' style={{ whiteSpace: 'nowrap' }}>{this.state.showElements ? translate('Hide List') : translate('Show List')}</p>
                    </button>
                </div> */}
                <ButtonAnimated
                    iconwidth='24px'
                    onClick={this.save}
                    title={translate("Save")}
                    isLoading={this.state.isLoadingView}
                    icon='/assets/icons/arrow-right-white.svg'
                    textColor={this.props.colors?.iconInvert ? '#fff' : '#000'}
                    invert={!this.props.colors?.iconInvert}
                    bg={this.props.colors?.iconInvert ? '#000' : '#fff'}
                />

            </div>

        )
    }

    toggleShowElements = () => {
        this.setState({ showElements: !this.state.showElements }, () => {
            this.props.setHeader("showElements", this.state.showElements)
        })
    }






    getFlows = () => {
        // console.log('this.props.data.name',this.props.rawDynamicStructures)
        let data = this.props.data

        this.setState({ components: this.props.components, paths: this.props.paths, flowName: data?.name, data: this.props.data, automationId: data?._id, variablesList: this.props.variablesList, optionsList: this.props.optionsList, dynamicStructureFrames: data?.dynamicStructureFrames }, () => {
            this.updateOptionsListOfDagramVariables(this.props.diagramVariables, this.props.rawDynamicStructures)

            this.props.setHeader("dummy", 1)
        })
        return
        // console.log('getflows')
        let _id = this.props.windowData?.path[this.props.baseUrl?.length]
        // console.log('get Page', _id)
        if (_id != "new" && _id != null) {

            // GET PAGE
            let data = {}
            data._id = _id
            data.applet = this.props.variables.appletId
            HttpServices.request('getAutomation', data, (fetchResult, fetchError) => {
                // console.log('fethcresult1-', fetchResult)
                let automation = fetchResult.automation
                if (automation && automation.flow) {

                    let components = this.state.components
                    let paths = this.state.paths
                    components = automation.flow?.components
                    paths = automation.flow?.paths
                    let optionsList = this.state.optionsList
                    optionsList.variables = { list: fetchResult.variables, sort: 1, label: 'variables', key: 'variables' }
                    let index = 2
                    fetchResult.frames.forEach((element) => {
                        optionsList[element._id] = { list: element.fields, sort: index, label: element.name, key: element._id }
                        index += 1
                    })
                    optionsList['diagramVariables'] = { list: [], sort: index, label: 'system variable', key: 'diagramVariables' }
                    this.setState({ components, paths, flowName: automation.name, data: automation, automationId: automation._id, variablesList: fetchResult.variables, optionsList }, () => {
                        this.props.setHeader("dummy", 1)
                    })
                }
            })
        }
        // let automation = this.props.data
        // console.log('automation32', automation)

        // let data = {
        //     applet: this.props.applet._id
        // }
        // let components = this.state.components
        // let paths = this.state.paths
        // HttpServices.request('getFlows', data, (fetchResult, fetchError) => {
        //     console.log('get stage fetchResult', fetchResult)
        //     components = fetchResult.info[0].flow.components
        //     paths = fetchResult.info[0].flow.paths
        //     console.log(components)
        //     console.log(paths)

        //     this.setState({ components, paths, data: fetchResult.info[0], automationId: fetchResult.info[0]._id })

        // })
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateMiniViewSize)
        this.removeDoneEventListener()
    }


    // fetchData = () => {

    //     let id = this.props?.data?.params?.id

    //     if (id) {
    //         this.setState({ isLoadingData: true })

    //         HttpServices.request('getOneApplet', { id }, (fetchResult, fetchError, fetchStatus) => {
    //             this.setState({ isLoadingData: false })
    //             // console.log(fetchError)
    //             if (fetchError) {
    //                 this.setState({ pageStatus: fetchStatus })
    //                 this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
    //                 return
    //             }
    //             if (!fetchResult.info?.workflow) {
    //                 fetchResult.info.workflow = {}
    //             }
    //             // console.log(fetchResult)
    //             this.setState({
    //                 data: fetchResult.info,
    //                 // components: fetchResult.info?.workflow.components ?? {},
    //                 // paths: fetchResult.info?.workflow.paths ?? {},
    //                 // nodes: fetchResult.info?.workflow.nodes ?? {},
    //             }, () => {
    //                 this.updateMiniViewSize()
    //                 this.fetchVariables()
    //             })
    //         })
    //     }
    // }



    // fetchVariables = () => {
    //     // this.fetchTings()
    // }


    // fetchTings = () => {
    //     HttpServices.request('getAppletThings', { applet: this.state.data?._id }, (fetchResult, fetchError, fetchStatus) => {
    //         this.setState({ isLoadingData: false })
    //         // console.log(fetchError)
    //         if (fetchError) {
    //             // this.setState({ pageStatus: fetchStatus })
    //             this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
    //             return
    //         }
    //         console.log(fetchResult)
    //         this.setState({ things: fetchResult.info }, () => {
    //             this.createOptionsList()
    //         })
    //     })
    // }



    createOptionsList() {
        let list = []
        list.push({ key: 'things', label: 'Things', parent: null, hasChildren: true })

        // this.state.things.forEach(connection => {
        //     // console.log(connection.thing)
        //     list.push({ key: "things." + connection.thing._id, label: connection.thing.name.replaceAll(' ', '-'), parent: "things", image: connection.thing.images, hasChildren: true })

        //     if (connection.thing.structure) {
        //         connection.thing.structure.forEach(structure => {
        //             list.push({ key: 'things.' + connection.thing.name.replaceAll(' ', '-') + '.' + structure.dataObject + '(' + connection.thing._id + ")", label: structure.label, parent: "things." + connection.thing._id })
        //         });
        //     }
        // });

        // // console.log(this.state.tempInputs)

        // if (Array.isArray(this.state.tempInputs)) {

        //     list.push({ key: 'inputs', label: 'Inputs', parent: null, hasChildren: true })

        //     this.state.tempInputs.forEach(input => {
        //         list.push({ key: "inputs." + input.label, label: input.label, parent: "inputs", hasChildren: false })
        //     })
        // }
        // console.log("createOptionsList")
        // console.log(list)
        this.setState({ optionsList: list })
    }


    formLiveChange = (data, init, key, value) => {
        // console.log(init)
        // console.log("formLiveChange")
        let currentHeadersData = this.state.currentHeadersData
        // console.log('currentHeadersData', currentHeadersData)
        if (this.state.currentComponent?.type == 'condition') {
            this.setState({ tempInputs: data.inputs }, () => {
                // this.createOptionsList()
            })
            // console.log(data)

        } else {
            if (init) {
                this.setState({ tempInputs: [{ label: 'input' }] }, () => {
                    // this.createOptionsList()
                })
            }
        }
        if (key == 'permissionsType') {
            currentHeadersData[key] = value
            if (value == 'custom' && !currentHeadersData.admins) {
                console.log('this.state.admins', this.state.admins)
                currentHeadersData.admins = this.state.admins ? JSON.parse(JSON.stringify(this.state.admins)) : null
            }
            this.setState({ currentHeadersData })
        }
    }



    // postRigram = () => {


    //     let data = {
    //         _id: this.state.data._id,
    //         workflow: {
    //             components: this.state.components,
    //             paths: this.state.paths,
    //             nodes: this.state.nodes
    //         }
    //     }

    //     // console.log(data)

    //     this.setState({ isLoadingPost: true })
    //     console.log('datais10000', data)
    //     HttpServices.request("postRigram", data, (fetchResult, fetchError) => {
    //         this.setState({ isLoadingPost: false })

    //         if (fetchError) {
    //             this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.postDataFailed', description: fetchError.message })
    //             return
    //         }

    //         this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postSuccesfully', description: '{{lang}}info.postSuccesfullyDesc' })

    //     })

    // }



    onDragStart = (e, prop, type, info) => {

        // console.log("onDragStart", info)
        // console.log("onDragStart", prop)
        // console.log("type", type)
        // console.log("this[prop.key]", this[prop.key])


        if (!e.dataTransfer) {
            e.dataTransfer = {}
        }
        if (type == 'component') {
            this.draggingId = prop.key
            if (e.dataTransfer.setDragImage) {
                e.dataTransfer.setDragImage(this.ghost, 0, 0);
            }
            if (this[prop.key]) {
                let bound = getBoundingClientRect(this[prop.key].container)
                let containerBound = getBoundingClientRect(this.rigramDroppable)

                let clientX = e.clientX
                let clientY = e.clientY

                if (e.touches) {
                    clientX = e.touches[0].clientX
                    clientY = e.touches[0].clientY

                    // document.getElementById('rigramDroppableView').style.overflow = 'hidden'
                    document.getElementById('rigramDroppable').style.overflow = 'hidden'

                }

                this.offsetX = clientX - ((bound.left * 1) + (bound.width * 1 / 2))
                this.offsetY = clientY - ((bound.top * 1) + (bound.height * 1 / 2))
                this.oldLeft = bound.left
                this.oldTop = bound.top

            }
        } else {
            this.offsetX = 0
            this.offsetY = 0
        }

        // console.log(e)

        if (e.dataTransfer.setData) {
            e.dataTransfer.setData('id', prop.key)
            e.dataTransfer.setData('type', prop.key)
            e.dataTransfer.setData('info', JSON.stringify(info))
        } else {
            e.dataTransfer.id = prop.key
            e.dataTransfer.type = prop.key
        }




    }

    setData = (key, value, reference, cb) => {
        if (reference == 'DiagramEditor') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {

                })
            }
        }
    }
    onDrag = (e) => {

        // console.log("onDrag")
        // console.log("components", this.state.components)
        // console.log("path", this.state.paths)
        // console.log("node", this.state.nodes)
        let x = e.clientX /// this.state.zoom
        let y = e.clientY /// this.state.zoom



        let bound = getBoundingClientRect(this.rigramDroppable)
        // console.log(bound)

        if (e.touches) {
            x = e.touches[0].clientX
            y = e.touches[0].clientY
        }

        // console.log(e.clientX)

        // console.log(x)
        // console.log(y)


        x = x - bound.left
        y = y - bound.top

        if (x < 0) {
            x = 0
        }

        if (y < 0) {
            y = 0
        }



        let components = this.state.components

        // let oldX = this[this.draggingId].container.style.left
        // let oldY = this[this.draggingId].container.style.top

        if (this.draggingId != null && x && y) {

            // console.log(x)
            // console.log(y)

            // console.log(this.rigramDroppable.scrollLeft)
            // console.log(this.rigramDroppable.scrollTop)

            let componentX = (((x - this.offsetX)) + (this.rigramDroppable.scrollLeft)) / this.state.zoom
            let componentY = (((y - this.offsetY)) + (this.rigramDroppable.scrollTop)) / this.state.zoom


            if (componentX < 70) {
                componentX = 70
            }
            if (componentY < 70) {
                componentY = 70
            }

            // console.log(this.draggingId)
            // console.log(componentX)
            // console.log(componentY)


            this[this.draggingId].container.style.left = componentX + 'px'
            this[this.draggingId].container.style.top = componentY + 'px'


            let ratio = (this.miniWidth / this.rigramDroppable.scrollWidth)///this.state.zoom

            this['mini-' + this.draggingId].style.left = (componentX) * ratio * this.state.zoom + 'px'
            this['mini-' + this.draggingId].style.top = (componentY) * ratio * this.state.zoom + 'px'

            components[this.draggingId].positionX = componentX
            components[this.draggingId].positionY = componentY
            // console.log("HEREEE")
            if (components[this.draggingId].paths) {
                let paths = this.state.paths ?? {}
                Object.values(components[this.draggingId].paths).forEach(path => {
                    // this.debounceFunc(path.key, path.as, [componentX, componentY]);
                    if (paths[path.key]) {
                        paths[path.key][path.as] = [componentX, componentY]
                    }

                });

                this.debounceFunc(paths);

            }
        }


        // let innerWidth = this.rigramDroppable.scrollLeft + bound.width
        // console.log(this.oldLeft)
        // console.log(x)


        if (x >= this.props.width - 200) {

            this.rigramDroppable.scrollLeft = this.rigramDroppable.scrollLeft + 2
            // this.rigramDroppable.scrollWidth = this.rigramDroppable.scrollWidth + 500


        }

        if (y >= this.props.height - 200) {
            this.rigramDroppable.scrollTop = this.rigramDroppable.scrollTop + 2
        }



        // let newWidth = this.rigramDroppable.scrollLeft + bound.width

        // if (newWidth > this.rigramDroppable.style.width) {

        //     this.rigramDroppable.style.width = newWidth
        //     console.log("ChangeWidth,", newWidth)
        // }


    }

    onDragOver = (e) => {
        e.stopPropagation();
        e.preventDefault();
    }





    onDrop = (e) => {
        // console.log("onDrop")
        // console.log(e.touches)
        // console.log(e.changedTouches)

        e.preventDefault()


        let components = this.state.components ?? {}
        let x = e.clientX
        let y = e.clientY


        if (e.changedTouches) {
            x = e.changedTouches[0].clientX
            y = e.changedTouches[0].clientY
        }

        let bound = getBoundingClientRect(this.rigramDroppable)

        x = x - bound.left
        y = y - bound.top



        let componentX = (((x - this.offsetX)) + (this.rigramDroppable.scrollLeft)) / this.state.zoom
        let componentY = (((y - this.offsetY)) + (this.rigramDroppable.scrollTop)) / this.state.zoom

        let ratio = this.miniWidth / this.rigramDroppable.scrollWidth

        // console.log(e.dataTransfer)
        let id
        let type
        let info
        if (e.dataTransfer.getData) {
            id = e.dataTransfer.getData('id')
            type = e.dataTransfer.getData('id')
            // info = e.dataTransfer?.getData('info') != undefined && JSON?.parse(e.dataTransfer?.getData('info'))
            // info = JSON?.parse(e.dataTransfer?.getData('info'))
            info = e.dataTransfer?.getData('info') != 'undefined' ? JSON?.parse(e.dataTransfer?.getData('info')) : null
        } else {
            id = e.dataTransfer.id
            type = e.dataTransfer.id
            info = typeof e.dataTransfer.info == 'object' ? e.dataTransfer.info : JSON.parse(e.dataTransfer.info)

        }

        // console.log('components', components)

        if (id && components[id]) {

            components[id].positionX = componentX //e.clientX + this.rigramDroppable.scrollLeft
            components[id].positionY = componentY //e.clientY + this.rigramDroppable.scrollTop
            this.setState({ components }, () => {
                // console.log("components", components)
                if (components[id].paths) {
                    let paths = this.state.paths ?? {}
                    // console.log(paths)
                    Object.values(components[id].paths).forEach(path => {
                        if (paths[path.key]) {
                            paths[path.key][path.as] = [componentX, componentY]
                        }

                    });

                    this.setState({ paths })
                }
            })

        } else {



            id = uuidv4()
            if (diagramComponents[type]) {
                let nodes = diagramComponents[type].defaultNodes ?? {}
                let title = diagramComponents[type].title
                let UI = diagramComponents[type].UI
                let group = diagramComponents[type].group
                let configuration = diagramComponents[type]?.configuration ?? {}


                this.checkComponentValidity(type, group, (valid, err) => {


                    if (err) {
                        this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.notValid', description: checkTranslation(err) })
                        return
                    }
                    // let settings = diagramComponents[type].settings

                    // let title = diagramComponents[type].title
                    console.log("configuration",configuration,info)

                    // console.log(id)
                    components[id] = { key: id, type, group, positionX: componentX, positionY: componentY, nodes, title, UI,configuration } // TODO DEFAULT NODES - Title
                    if (info) {
                        // console.log('info is', info)
                        // if (!components[id].configuration) {
                        //     components[id].configuration = {}
                        // }

                        if (!components[id].configuration.applet) {
                            components[id].configuration.applet = info._id
                        }

                        if (!components[id].configuration.key) {
                            components[id].configuration.key = id
                        }

                        if (!components[id].configuration.id) {
                            components[id].configuration.id = id
                        }
                    }
                    this.setState({ components }, () => {
                        // console.log('nodes is', this.state.nodes)

                        this[id].container.style.left = components[id].positionX + 'px'
                        this[id].container.style.top = components[id].positionY + 'px'

                        this['mini-' + id].style.left = (components[id].positionX) * ratio * this.state.zoom + 'px'
                        this['mini-' + id].style.top = (components[id].positionY) * ratio * this.state.zoom + 'px'

                        // Do config
                    })
                })

            }


        }

    }

    checkComponentValidity = (type, group, cb) => {

        let components = Object.values(this.state.components ?? {})
        let valid = true
        let error

        if (type == "workflowStart") {
            components.forEach(component => {
                if (component.type == type) {
                    valid = false
                    error = `{{lang}}Only on "Workflow start" is valid in a workflow.`
                }
            });
        }
        cb(valid, error)
    }

    dragEnd = (e) => {
        // console.log("dragEnd")
        // let rigramDroppable = document.getElementById('rigramDroppableView')
        // // console.log(rigramDroppable)
        // rigramDroppable.style.overflow = 'auto'

        document.getElementById('rigramDroppableView').style.overflow = 'visible'
        document.getElementById('rigramDroppable').style.overflow = 'auto'



        this.updateMiniViewSize()
    }




    updateMiniViewSize = (e) => {

        if (this.rigramDroppable) {

            let ratio = (this.miniWidth / this.rigramDroppable.scrollWidth)

            let newHeight = this.rigramDroppable.scrollHeight * ratio ///this.rigramDroppable.scrollWidth

            let trackerNewWidth = (this.props.width - 50) * ratio///this.rigramDroppable.scrollWidth)*200
            let trackerNewHeight = ((this.props.height - 50) / this.rigramDroppable.scrollHeight) * newHeight

            this.miniView.style.height = newHeight + 'px'
            // this.miniView.style.width = newHeight + 'px'

            // console.log(ratio)
            // console.log(trackerNewHeight)
            // console.log(trackerNewWidth)
            // console.log(this.props.height)


            this.miniViewTracker.style.height = trackerNewHeight + 'px'
            this.miniViewTracker.style.width = trackerNewWidth + 'px'


            this.miniViewTracker.style.top = (this.rigramDroppable.scrollTop * ratio) + 'px'
            this.miniViewTracker.style.left = (this.rigramDroppable.scrollLeft * ratio) + 'px'

            Object.values(this.state.components).forEach(component => {
                this.updateMiniViewComponent(component, ratio)
            });
        }

    }


    updateMiniViewComponent(component, sRatio) {
        let ratio = sRatio
        if (!ratio) {
            ratio = (this.miniWidth / this.rigramDroppable.scrollWidth)
        }
        ratio = ratio * this.state.zoom
        this['mini-' + component.key].style.left = (component.positionX) * ratio + 'px'
        this['mini-' + component.key].style.top = (component.positionY) * ratio + 'px'
    }


    handleZoom(type) {

        let zoom = this.state.zoom

        if (type == 'in') {
            if (zoom <= 2) {
                zoom = zoom + 0.2
            }
        }

        if (type == 'out') {
            if (zoom >= 0.5) {
                zoom = zoom - 0.2
            }

        }

        if (type == 'fit') {
            zoom = 1
        }

        this.setState({ zoom }, () => {
            this.updateMiniViewSize()
        })

    }



    toggleMiniView = () => {
        let miniClose = this.state.miniClose == null ? true : !this.state.miniClose
        this.setState({ miniClose })
    }



    setNodesPosition = (componentKey, nodes, componentWH) => {
        // console.log('setNodesPosition')
        let components = this.state.components
        // Object.values(nodes).forEach(node => {
        //     node.relativePosition.x = this.rigramDroppable.scrollLeft + node.relativePosition.x
        //     node.relativePosition.y = this.rigramDroppable.scrollTop + node.relativePosition.y
        // });

        components[componentKey].nodes = Object.assign({}, nodes)
        if (componentWH) {
            components[componentKey].width = componentWH.width
            components[componentKey].height = componentWH.height
        }

        // console.log(components)

        this.setState({ components })
        // console.log(components[componentKey])

    }


    nodeMouseDown = (component, node, e) => {
        // console.log("nodeMouseDown", this.state.paths)
        let components = this.state.components

        if (this.state.activePath) {
            let activePath = this.state.activePath ?? {}
            if (node.type === 'input') {
                // console.log("*")
                let paths = this.state.paths ?? {}
                let id = uuidv4()
                activePath.id = id
                activePath.key = id

                let x = components[component.key].positionX //+ 
                let y = components[component.key].positionY //+ node.relativePosition.y 

                let endOffset = [node.relativePosition.x, node.relativePosition.y]


                activePath.end = [x, y]
                activePath.endOffset = endOffset

                activePath.ECKey = component.key
                activePath.ENKey = node.key
                // console.log('tp1')
                paths[id] = activePath


                this.setState({ activePath: null, paths })

                if (!components[component.key].paths) {
                    components[component.key].paths = {}
                }
                if (!components[activePath.SCKey].paths) {
                    components[activePath.SCKey].paths = {}
                }

                components[component.key].paths[id] = { as: 'end', key: id, node: node.key }
                components[activePath.SCKey].paths[id] = { as: 'start', key: id, node: activePath.SNKey }

                // console.log(paths)
                // console.log(components)

                // paths.push()

            }
        } else {

            if (node.type === 'output') {

                // let x = components[component.key].positionX + node.relativePosition.x //+ node.relativePosition.width / 2
                // let y = components[component.key].positionY + node.relativePosition.y //+ node.relativePosition.height / 2


                let x = components[component.key].positionX //+ node.relativePosition.x 
                let y = components[component.key].positionY //+ node.relativePosition.y 

                let bound = getBoundingClientRect(this.rigramDroppable)




                let clientX = ((e.clientX - bound.left) + (this.rigramDroppable.scrollLeft)) / this.state.zoom
                let clientY = ((e.clientYy - bound.top) + (this.rigramDroppable.scrollTop)) / this.state.zoom


                let start = [x, y]
                let startOffset = [node.relativePosition.x, node.relativePosition.y]

                let end = [clientX, clientY]
                let endOffset = [0, 0]

                // console.log(start)
                // console.log(end)
                let activePath = {}
                activePath.start = start
                activePath.end = end
                activePath.startOffset = startOffset
                activePath.endOffset = endOffset

                activePath.SCKey = component.key
                activePath.SNKey = node.key
                this.setState({ activePath })
                window.addEventListener('mousemove', this.updateActivePath)
                window.addEventListener('touchmove', this.updateActivePath)
                setTimeout(() => {
                    window.addEventListener('touchstart', this.finishActivePath)
                    window.addEventListener('mousedown', this.finishActivePath)

                }, 2);
            }
        }
    }


    updateActivePath = (e) => {
        let activePath = this.state.activePath//{ points: { start, end } }

        let bound = getBoundingClientRect(this.rigramDroppable)


        let clientX = ((e.clientX - bound.left) + (this.rigramDroppable.scrollLeft)) / this.state.zoom
        let clientY = ((e.clientY - bound.top) + (this.rigramDroppable.scrollTop)) / this.state.zoom

        activePath.end = [clientX, clientY]
        // console.log('activePath', activePath)
        this.setState({ activePath })
    }


    finishActivePath = (e) => {
        window.removeEventListener('touchmove', this.updateActivePath)
        window.removeEventListener('touchstart', this.finishActivePath)

        window.removeEventListener('mousemove', this.updateActivePath)
        window.removeEventListener('mousedown', this.finishActivePath)

        setTimeout(() => {
            this.setState({ activePath: null })
        }, 300);
    }

    removePath = (id) => {
        // console.log('removePath')
        let paths = this.state.paths
        let path = paths[id]

        if (path) {
            let components = this.state.components

            // console.log(components)
            // console.log(paths)

            if (components[path.ECKey]?.paths) {
                delete components[path.ECKey].paths[path.id]
            }

            if (components[path.SCKey]?.paths) {
                delete components[path.SCKey].paths[path.id]
            }

            delete paths[id]

            this.setState({ paths, components })
        }
    }


    removeCurrentComponent = () => {
        let key = this.state.currentComponent.key
        let components = this.state.components
        let paths = this.state.paths
        // console.log(paths)
        let pathsToremove = []
        Object.values(paths).forEach((path, index) => {
            if (path.ECKey == key || path.SCKey == key) {
                pathsToremove.push(path)
            }
        });

        this.moreModal.hideModal()
        this.removeConfirmModal.hideModal()

        pathsToremove.forEach(path => {
            this.removePath(path.id)
        });

        delete components[key]
        this.setState({ components, currentComponent: null, paths })

    }



    openMore = (key, isDoubleClick) => {
        // console.log(key)
        let component = this.state.components[key]
        let diagramComponent = diagramComponents[component.type]
        // console.log(component)
        this.setState({ currentComponent: component, currentDiagramComponent: diagramComponent }, () => {

            if (isDoubleClick) {
                this.openConfig()
            } else {
                this.moreModal.showModal()
            }

        })


    }

    openConfig = () => {
        let component = this.state.currentComponent

        // console.log('casvfwregewdwq', component)
        let headersData = component.configuration
        // console.log(headersData)

        if (!headersData) {
            headersData = {}
        }

        headersData.label = component.title
        // console.log('headers', headersData)
        this.setState({ currentHeadersData: headersData }, () => {

            this.diagramComponentConfig.openSidebar()
            // this.configModal.showModal(() => {
            //     // console.log("??INIT")
            //     // setTimeout(() => {
            //     //     if (this.form) {
            //     //         console.log("INIT")
            //     //         this.form.init()
            //     //     } 
            //     // }, 100);

            // })
        })

        window.addEventListener("keypress", this.donePressed)
        // window.addEventListener()
        setTimeout(() => {
            if (this.moreModal) {
                this.moreModal.hideModal()
            }
        }, 100);
    }

    donePressed = (e) => {
        // e.preventDefault()
        if (e?.keyCode == 13) {
            this.ConfigurationDone()
        }
    }

    removeDoneEventListener() {
        window.removeEventListener("keypress", this.donePressed)
    }


    ConfigurationDone = () => {
        let headersData = this.form.getForm()
        if (headersData) {
            let components = this.state.components
            let key = this.state.currentComponent.key
            // let component = components[key]
            components[key].title = headersData.label
            components[key].configuration = headersData

            let nodes = {}
            if (headersData.inputs) {
                // console.log(components[key])
                headersData.inputs.forEach(input => {
                    let object = { type: 'input', position: 'left' }
                    object.key = input.label
                    object.label = input.label
                    nodes[input.label] = object
                });
            }

            if (headersData.outputs) {
                headersData.outputs.forEach(output => {
                    let object = { type: 'output', position: 'right' }
                    object.key = output.label
                    object.label = output.label
                    nodes[output.label] = object
                });
            }

            if (Object.keys(nodes).length > 0) {
                components[key].nodes = nodes
            }

            this.setState({ components }, () => {
                this.configModal.hideModal()

                if (Object.keys(nodes).length > 0) {
                    this[key].setNodesPosition()
                    setTimeout(() => {
                        this.repositionPaths(key)
                    }, 400);
                }

                // console.log(this.state.components)
                // console.log(this.state.paths)

            })
        }

    }


    repositionPaths(key) {

        // console.log("repositionPaths")

        let paths = this.state.paths
        let components = this.state.components
        let nodes = components[key].nodes
        // console.log(nodes)

        let x = components[key].positionX
        let y = components[key].positionY

        if (paths) {
            Object.values(paths).forEach(path => {
                let inputKey = null
                if (path.SCKey == key) {
                    inputKey = "SNKey"
                }
                if (path.ECKey == key) {
                    inputKey = "ENKey"
                }

                if (inputKey) {

                    let connectedNode

                    Object.values(nodes).forEach(node => {
                        if (node.key == path[inputKey]) {
                            connectedNode = node
                        }
                    })

                    if (connectedNode) {

                        if (inputKey == "SNKey") {
                            path.start = [x, y]
                            path.startOffset = [connectedNode.relativePosition.x, connectedNode.relativePosition.y]
                        }

                        if (inputKey == "ENKey") {
                            path.end = [x, y]
                            path.endOffset = [connectedNode.relativePosition.x, connectedNode.relativePosition.y]
                        }

                    } else {
                        this.removePath(path.id)
                    }

                }

            });
        }

        this.setState({ paths }, () => {
        })

    }


    // saveButton(action) {
    //     return (
    //         <div className="flexc mx-2">

    //             <LoaderButton
    //                 onClick={() => action()}
    //                 isLoading={this.state.isLoading}
    //                 text={translate("Save").toUpperCase()}
    //                 type={"Oval"}
    //                 className=""
    //                 buttonStyle={{ outline: 'none', backgroundColor: '#222', cursor: 'pointer', padding: '5px 20px', borderRadius: 30, fontSize: 15, fontWeight: 'bold', color: '#fff', border: 'none' }}
    //                 width={30}
    //                 height={30}
    //                 color={'#202020'}
    //             />
    //             {/* <button className="" onClick={() => action()} style={{ backgroundColor: '#222530', color: '#fff', borderRadius: 40, padding: '5px 20px', fontWeight: 'bold' }}>SAVE</button> */}
    //             {/* <button onClick={() => this.props.nextStage()} style={{ backgroundColor: '#202020', color: '#fff', borderRadius: 30, padding: '5px 15px', fontWeight: 'bold' }}>NEXT</button> */}
    //         </div>
    //     )
    // }
    makeStages = (stages, componentId, cb, list = []) => {
        let components = this.state.components
        if (!componentId) {
            Object.values(components).map((component) => {
                if (component.group == 'trigger') {
                    componentId = component.key
                }
            })
        }
        if (components[componentId]) {
            this.addStageObject(stages, components[componentId])
            list.push(componentId)
            let findNewId
            for (let index = 0; index < Object.values(components).length; index++) {
                const component = Object.values(components)[index];
                if (!list.includes(component.key) && component.type == 'stage') {
                    componentId = component.key
                    findNewId = true
                    break
                }
            }
            if (findNewId) {
                this.makeStages(stages, componentId, cb, list)
            } else {
                cb()
            }

        }


    }
    addStageObject = (stages, component) => {
        // console.log('*addStageObject', component)
        let paths = this.state.paths
        let obj = {
            id: component.key,
            name: component.title,
            color: component.configuration.color,
            to: [],
        }
        if (component.group == 'trigger') {
            obj.type = 'trigger'
            obj.key = 'workflowStart'
        }
        Object.values(paths).map((path) => {
            if (path.SCKey == component.id)
                obj.to.push(path.ECKey)
        })
        stages.push(obj)
        // console.log('stages', stages, 'obj', obj)
        return stages
    }


    save = () => {

        // console.log("SAVE")
        this.setState({ isLoadingView: true })
        let data = {}
        // this.makeStages(data.stages, null, () => {
        // console.log('stages', data.stages)
        data._id = this.state.automationId
        // data.collection = this.props.variables
        data.collection = this.props.data?.frame
        data.applet = this.props.applet._id
        data.name = this.state.flowName
        data.flow = { components: this.state.components, paths: this.state.paths }
        data.diagramVariables = this.state.diagramVariables
        data.dynamicStructureFrames = this.state.dynamicStructureFrames

        // console.log('dataaaaa', data)
        // return
        HttpServices.request('postFlow', data, (fetchResult, fetchError) => {
            this.setState({ isLoadingView: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.TypeRequired', description: translate("") })
                return
            }
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.savedSuccesfully', description: '{{lang}}info.dataSavedSuccessfully' })
            // console.log('fetchhhhres', fetchResult)
            // console.log('fetchhhherr', fetchError)

            // console.log('onsave')
        })
        // })

    }



    updateOptionsListOfDagramVariables = (diagramVariables, rawDynamicStructures) => {


        if (diagramVariables && typeof diagramVariables == 'object') {

            let optionsList = this.state.optionsList

            optionsList['diagramVariables'].list = []

            for (let j = 0; j < Object.values(diagramVariables).length; j++) {

                const value = JSON.parse(JSON.stringify(Object.values(diagramVariables)[j]))
                let structure


                // console.log(value)
                if (value.isDynamic && rawDynamicStructures) {


                    let componentKey = value.key.split('_')[0]

                    // console.log("component", rawDynamicStructures)
                    // console.log("component.key", componentKey, rawDynamicStructures[componentKey])


                    if (Array.isArray(rawDynamicStructures[componentKey])) {

                        value.structure = rawDynamicStructures[componentKey][0]?.fields
                        let myFields = []
                        rawDynamicStructures[componentKey].forEach(frame => {

                            if (Array.isArray(frame.fields)) {
                                frame.fields.forEach(frameField => {
                                    let found = false

                                    myFields.forEach(paramField => {

                                        if (frameField.information?.label == paramField.information?.label) {
                                            found = true
                                        }

                                    })

                                    if (!found) {
                                        myFields.push(frameField)
                                    }

                                })
                            }

                        })



                        value.structure = myFields

                    }
                }

                if (value.structure) {
                    structure = []

                    if (value.structure && value.structure[0]?.pageContent) {
                        value.structure[0]?.pageContent.forEach(pageContent => {

                            pageContent.sectionContent.forEach(sectionContent => {

                                sectionContent.rowContent.forEach(rowContent => {
                                    rowContent.information.disabled = true
                                    structure.push(rowContent)
                                });

                            });


                        });



                    } else {
                        structure = value.structure ?? []
                    }

                    if (value.dataType == "record") {
                        // console.log("HEREE", value)
                        structure.push({ key: 'frame', type: 'frame', information: { label: 'Frame' } })
                        structure.push({ key: 'applet', type: 'applet', information: { label: 'Applet' } })
                    }

                }


                optionsList['diagramVariables'].list.push({ key: value.key, name: value.name, type: value.dataType, componentKey: value.componentKey, fieldTypes: value.fieldTypes, isDynamic: value.isDynamic, dynamicStructureFrames: value.dynamicStructureFrames, structure: structure, })

            }

            this.setState({ optionsList, diagramVariables, rawDynamicStructures })
        }
    }


    getFramesParams = (component, frames) => {

        // console.log(component)
        // console.log(frames)
        let body = { frames: frames }

        this.setState({ isLoadingFramesFields: true })

        HttpServices.request('getFramesFields', body, (fetchResult, fetchError) => {

            // console.log(fetchResult, fetchError)

            this.setState({ isLoadingFramesFields: false })

            if (fetchError) {
                this.setState({ fetchError })
                return
            }

            let diagramVariables = this.state.diagramVariables
            let rawDynamicStructures = this.state.rawDynamicStructures ?? {}

            rawDynamicStructures[component.key] = fetchResult.info
            // for (const [key, value] of Object.entries(diagramVariables)) {

            //     if (key.startsWith(component.key) && value.isDynamic) {

            //         console.log("component.key", component.key)

            //         value.structure = fetchResult.info[0]?.fields
            //     }
            // }

            // console.log(fetchResult.info)
            // console.log("diagramVariables", diagramVariables)

            this.updateOptionsListOfDagramVariables(diagramVariables, rawDynamicStructures)


            // this.setState({ diagramVariables })

            // diagramVariables[myKey].structure

            // let dynamicStructureFields = this.state.dynamicStructureFields ?? {}

            // dynamicStructureFields[component.key] = []

        })

    }



    saveConfig = (config, component) => {

        // console.log('onsave', config, component)
        // console.log('onsave',  config)

        // let components = this.state.components
        // components[component.key].configuration = config
        // this.setState({ components })
        // let headersData = this.form.getForm()
        // console.log('config', config)
        // console.log('component', component)
        // return

        let diagramVariables = this.state.diagramVariables
        let dynamicStructureFrames = this.state.dynamicStructureFrames ?? {}

        let refComponent = diagramComponents[component.type]

        if (refComponent && Array.isArray(refComponent.headers)) {

            for (let i = 0; i < refComponent.headers.length; i++) {
                const header = refComponent.headers[i];
                if (header.information?.isVariableName == true) {

                    let myKey = component.key + '_' + header.key

                    if (config[header.key] != null && config[header.key].trim() != '') {

                        for (let j = 0; j < Object.values(diagramVariables).length; j++) {
                            const value = Object.values(diagramVariables)[j];

                            if (value.name.toLowerCase() == config[header.key].toLowerCase() && value.key != myKey) {

                                // console.log(value.key, myKey)
                                // console.log(header)
                                // console.log(component)
                                // console.log(myKey)

                                // delete diagramVariables[value.key]

                                this.props.actions.addNotif({ type: 'error', title: '{{lang}}Variable name is not valid', description: '{{lang}}Variable name should be unique. You are already using this vaiable name for another component.' })
                                return
                            }
                        }

                        diagramVariables[myKey] = { name: config[header.key], key: myKey, componentKey: component.key, fieldKey: header.key, dataType: header.information?.type ?? 'string', fieldTypes: header.information?.fieldTypes }

                        let structureFields = header.information?.structureFields

                        // console.log(structureFields)
                        if (structureFields) {

                            if (structureFields == '*dynamic') {
                                diagramVariables[myKey].structure = null
                                diagramVariables[myKey].isDynamic = true

                                if (header.information.dynamicStructureFrames) {

                                    diagramVariables[myKey].dynamicStructureFrames = getObject(config, header.information?.dynamicStructureFrames)

                                    if (dynamicStructureFrames[component.key] != diagramVariables[myKey].dynamicStructureFrames) {
                                        dynamicStructureFrames[component.key] = diagramVariables[myKey].dynamicStructureFrames
                                        this.getFramesParams(component, diagramVariables[myKey].dynamicStructureFrames)
                                    }
                                } else {
                                    delete dynamicStructureFrames[component.key]
                                }

                            } else {
                                diagramVariables[myKey].isDynamic = false
                                diagramVariables[myKey].structure = getObject(config, structureFields)
                                delete dynamicStructureFrames[component.key]

                            }
                        } else {
                            if (header.information?.dynamicStructureFrames) {
                                diagramVariables[myKey].dynamicStructureFrames = getObject(config, header.information?.dynamicStructureFrames)
                            }
                        }
                        // delete diagramVariables[component.key+'-variable']
                    } else {

                        delete diagramVariables[myKey]

                    }



                }
            }

            // console.log(diagramVariables)
            this.updateOptionsListOfDagramVariables(diagramVariables)

            this.setState({ diagramVariables, dynamicStructureFrames })

        }


        let headersData = config
        if (headersData) {
            let components = this.state.components
            let key = this.state.currentComponent.key
            // let component = components[key]
            components[key].title = headersData.label
            components[key].configuration = headersData

            components[key].group = refComponent.group

            // console.log(components[key].group)
            // if (headersData.inputs) {
            //     // console.log(components[key])
            //     headersData.inputs.forEach(input => {
            //         let object = { type: 'input', position: 'left' }
            //         object.key = input.label
            //         object.label = input.label
            //         nodes[input.label] = object
            //     });
            // }
            // let nodes = {}

            let nodes = { input: components[key].nodes.input }
            if (headersData.outputs && component.type == "condition") {

                let elseCheck = false
                // console.log(headersData.outputs)
                headersData.outputs.forEach(output => {
                    // console.log('output233', output)
                    if (output.isElse == true) {
                        elseCheck = true
                    }
                    let object = { type: 'output', position: 'right', sort: output.sort }
                    object.key = output.key
                    object.label = output.label
                    nodes[output.key] = object
                });
                if (!elseCheck) {
                    // console.log(true)
                    // console.log('headdata')
                    headersData.outputs.push({ key: 'else', label: 'else', isElse: true })
                    let object = { type: 'output', position: 'right' }
                    object.key = 'else'
                    object.label = 'else'
                    nodes.else = object
                }

                if (Object.keys(nodes).length > 0) {

                    // console.log("nodes", nodes)

                    components[key].nodes = nodes
                }
            }




            this.setState({ components }, () => {
                this.configModal.hideModal()

                if (Object.keys(nodes).length > 0) {
                    this[key].setNodesPosition()
                    setTimeout(() => {
                        this.repositionPaths(key)
                    }, 40);
                }

                // console.log(this.state.components)
                // console.log(this.state.paths)

                this.diagramComponentConfig.close()
            })
        }
        // let data = {}
        // data.configuration = config
        // data._id = this.state.automationId
        // data.component = component.key
        // HttpServices.request('postConfiguration', data, (fetchResult, fetchError) => {

        //     console.log('configured')
        // })

    }

    render() {
        let ratio = 1
        if (this.rigramDroppable) {
            ratio = (this.miniWidth / this.rigramDroppable.scrollWidth) * this.state.zoom
        }

        // let variables = { appletId: this.state.data?._id, user: this.props.user.info, headers: this.props.headers, appletHub: this.props.applet.hub }
        let variables = {
            appletId: this.props.variables.appletId,
            user: this.props.user.info,
            headers: this.props.headers,
            appletHub: this.props.applet?.hub ?? this.props.variables.appletHub,
            appletHubId: this.props.applet?.hub?._id ?? this.props.variables.appletHubId,
            automationId:this.props.data?._id
        }

        // console.log(this.state.optionsList)
        return (

            <div className="w-100 d-flex Test diagram  h-100 window-content-radius " style={{ overflow: 'auto' }} >


                {/* 
                <div className="w-100 blur-back" style={{ position: 'fixed', height: 50, borderBottom: '1px solid #eee', zIndex: 8, padding: '10px 20px', backgroundColor: '#ffffffcc' }}>
                    <p>Rigram</p>
                </div> */}



                {/* <DiagramSidebar width={this.props.width} onDragStart={this.onDragStart} onDrop={this.onDrop} onTouchMove={this.onTouchMove} sideOpen={true} hideOverlay={true} draggable={true} /> */}

                {/* <DiagramTopbar setData={this.setData} variables={variables} variablesList={this.state.variablesList} showElements={this.state.showElements} width={this.props.width} onDragStart={this.onDragStart} onDrop={this.onDrop} onTouchMove={this.onTouchMove} sideOpen={true} hideOverlay={true} draggable={true} page={this.props.page} /> */}


                <div onScroll={(e) => this.updateMiniViewSize(e)} id="rigramDroppable" ref={el => this.rigramDroppable = el} className="rigramDroppable window-content-radius " onDrop={(e) => this.onDrop(e, 'complete')} onDragOver={(e) => this.onDragOver(e)} style={{ direction: 'ltr', overflow: 'auto', padding: 100, width: '-webkit-fill-available', height: 'calc( 100% - 50px)', zIndex: 5, background: '#f6f6f6', position: 'absolute', }}>
                    {/* backgroundImage: 'url(/images/dg-bg.jpg)', */}

                    <div id="rigramDroppableView" className="w-100 window-content-radius " style={{ transformOrigin: '0px 0px', transform: 'scale(' + this.state.zoom + ')', position: 'absolute', top: 0, left: 0, height: '100%', overflow: 'visible', }}>

                        {/* <div className="prd-2 pt-2" onClick={() => this.save()} style={{ cursor: 'pointer', position: 'absolute', right: 0 }}>
                            <button className="py-1 px-2 br-10" style={{ backgroundColor: '#eee' }}>
                                <p style={{ fontSize: '16px' }}>{translate('Save')}</p>
                            </button>
                        </div> */}
                        {this.state.components && Object.values(this.state.components).map((prop, index) => {
                            let thisFunction = diagramComponents[prop.type]
                            return (
                                <DiagramComponent ref={el => this[prop.key] = el} key={prop.key} data={prop} openMore={this.openMore} thisFunction={thisFunction} draggingId={this.draggingId} dragEnd={this.dragEnd} onDrag={this.onDrag} onDragStart={this.onDragStart} nodeMouseDown={this.nodeMouseDown} zoom={this.state.zoom} setNodesPosition={this.setNodesPosition} />
                            )
                        })}

                        {this.state.paths && Object.values(this.state.paths).map((prop, index) => {
                            // console.log(prop)
                            return (
                                <DiagramPath zIndex={-1} removePath={this.removePath} ref={el => this[prop.key] = el} key={prop.id} data={prop} draggingId={this.draggingId} dragEnd={this.dragEnd} onDrag={this.onDrag} onDragStart={this.onDragStart} zoom={this.state.zoom} arrowXOffest={-7} />
                            )
                        })}

                        {this.state.activePath && (
                            <DiagramPath zIndex={-1} isActivePath={true} ref={el => this.activePath = el} data={this.state.activePath} />
                        )}


                    </div>
                    {/* <div className='mt-3 px-2'>
                        <LoaderButton
                            onClick={() => this.postRigram()}
                            // isLoading={this.state.isLoading}
                            text={translate("Continue")}
                            // background='linear-gradient(to right, #0796A9, #3391FF)'
                            // background='linear-gradient(to right, #0094FF, #6100FF)'
                            icon={'/assets/icons/angle-right-white2.svg'}
                            backgroundImage='linear-gradient(45deg, #0094FF 0%, #6100FF 51%, #0094FF  100%)'
                            className={'button-interactive-1'}

                        />
                    </div> */}

                </div>


                {/* MINIVIEWER */}
                <div className={"miniViewContainer " + (this.state.miniClose ? 'miniClose' : '')} >
                    <div className="miniViewContainerContent">
                        <button className=" mx-1 flexcc zoomToggleBut" onClick={() => this.toggleMiniView()} >
                            <img src="/images/nexts.png" width="20px" />
                        </button>

                        <div className="miniView" ref={el => this.miniView = el} >

                            {this.state.components && Object.values(this.state.components).map((prop, index) => {
                                let thisFunction = diagramComponents[prop.type]

                                return (
                                    <div onDragEnd={(e) => this.dragEnd()} key={prop.key} ref={el => this['mini-' + prop.key] = el} style={{ padding: 30 / 200, position: 'absolute', transform: 'translate(-50%,-50%)' }}>
                                        <div style={{ backgroundColor: thisFunction?.UI?.bodyColorS == '#fff' ? '#ccc' : thisFunction?.UI?.bodyColorS, width: (prop.width ?? 1) * ratio, height: (prop.height ?? 1) * ratio, borderRadius: thisFunction?.UI?.type == "circle" ? '50%' : 3 }}>
                                        </div>
                                    </div>
                                )
                            })}

                            <div className="mini-view-tracker" ref={el => this.miniViewTracker = el} ></div>
                        </div>

                        <div className="flexcc flex-column mld-2 ">
                            <button className="p-0 m-1 flexcc zoomBut" onClick={() => this.handleZoom('in')} >
                                <img src="/images/zoom-in.svg" width="25px" />
                            </button>
                            <button className="p-0 m-1 flexcc zoomBut" onClick={() => this.handleZoom('out')}>
                                <img src="/images/zoom-out.svg" width="25px" />
                            </button>
                            <button className="p-0 m-1 flexcc zoomBut" onClick={() => this.handleZoom('fit')}>
                                <img src="/images/zoom-fit.svg" width="25px" />
                            </button>
                        </div>

                    </div>

                </div>
                <div ref={el => this.ghost = el} style={{ width: 1, height: 1, position: 'absolute' }}></div>




                <Modal ref={el => this.moreModal = el} maxWidth={320} hideCloseBut={true}>
                    <div className="w-100  text-center position-relative py-3 px-3" style={{ backgroundColor: '#ffffff', borderRadius: 8, boxShadow: "0px 0px 50px #10101030" }}>

                        {/* <div className="position-absolute top-0 left-0 w-100" style={{ borderRadius: '8px 8px 0px 0px', zIndex: 0, height: 80, background: 'linear-gradient(to bottom,#CFD3EF,#fff)', }}>

                        </div> */}
                        <div className="w-100 position-relative" style={{ zIndex: 1, }}>
                            <div className="w-100 flexcb" style={{ position: 'sticky', top: 0, }}>

                                <div className="text-start">
                                    {/* <p className="text-smallest mt-2 opacity-5" style={{ lineHeight: 0.5 }}>WHAT TO DO?</p> */}
                                    {/* <div className="br-6 p-1" style={{backgroundColor:this.props.color?.background??'#eee'}}>
                                        <img src={importedIcons.}/>
                                    </div> */}
                                    <p className="text-semibold text-normal">{checkTranslation(this.state.currentComponent?.title)}</p>
                                </div>

                                <div className="cursor-pointer" onClick={() => this.moreModal.hideModal()} style={{ width: 28, height: 28, backgroundColor: '#ffffff90', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img style={{ width: 10, height: 10, opacity: 0.7 }} src="/images/close.svg" alt="" />
                                </div>

                            </div>
                            <div className="pt-1">
                                <button onClick={() => this.openConfig()} className="py-3 w-100 flexc px-0" style={{ borderBottom: '1px solid #eee' }}>
                                    <img className="mrd-3" src={importedIcons.setting} width="24px" alt="" />
                                    <div className="text-start">
                                        <p className="font-size-14 weight-500 black text-normal pb-1">{translate('Configure')}</p>
                                        <p className="text-smaller" style={{ lineHeight: 1, color: '#777' }}>{translate('Double click on component for faster access')}</p>
                                    </div>
                                </button>



                                <button className="py-3 w-100 flexc px-0" style={{ borderBottom: '1px solid #eee' }}>
                                    <img className="mrd-3" src={importedIcons.copy} width="24px" />
                                    <p className="font-size-14 weight-500 black text-normal">{translate('Clone')}</p>
                                </button>

                                <button onClick={() => this.removeConfirmModal.showModal()} className="pt-3 px-0 w-100 flexc" style={{ borderBottom: '0px solid #eee' }}>
                                    <img className="mrd-3" src={importedIcons.trash} width="24px" />
                                    <p className="font-size-14 weight-500 black text-normal">{translate('Remove')}</p>
                                </button>

                            </div>
                        </div>
                    </div>
                </Modal>



                <Modal ref={el => this.removeConfirmModal = el} maxWidth={300} hideCloseBut={true}>
                    <div className="w-100  text-center position-relative" style={{ backgroundColor: '#ffffff', borderRadius: 8 }}>

                        <div className="position-absolute top-0 left-0 w-100" style={{ borderRadius: '8px 8px 0px 0px', zIndex: 0, height: 80, background: 'linear-gradient(to bottom,#FF617460,#fff)', }}>

                        </div>
                        <div className="position-relative px-4">
                            <div className="w-100 pt-3 pb-2" style={{ zIndex: 1, display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, borderBottom: '0px #eee solid', borderRadius: '8px 8px 0px 0px' }}>

                                {/* <div className="w-100" style={{ zIndex: 1, padding: '8px 15px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', position: 'sticky', top: 0, borderBottom: '0px #eee solid', backgroundColor: '#f2f6f8ee', background: 'linear-gradient(to right,#dd3030dd,#ee5050dd)', backdropFilter: 'blur(10px) saturate(180%)', WebkitBackdropFilter: 'blur(10px) saturate(180%)', borderRadius: '8px 8px 0px 0px' }}> */}

                                <div className="text-start">
                                    {/* <p className="text-smallest mt-2 opacity-5" style={{ lineHeight: 0.5 }}>WHAT TO DO?</p> */}
                                    <p className="text-normal text-semibold" >{translate('Remove')}</p>

                                </div>

                                <div className="cursor-pointer" onClick={() => this.removeConfirmModal.hideModal()} style={{ width: 28, height: 28, backgroundColor: '#ffffff90', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img style={{ width: 10, height: 10, opacity: 0.7 }} src="/images/close.svg" alt="" />
                                </div>
                                {/* <div className="cursor-pointer" onClick={() => this.removeConfirmModal.hideModal()} style={{ width: 30, height: 30, borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img className="invert" style={{ width: 14, height: 14 }} src="/assets/icons/useful/close.svg" alt="" />
                                </div> */}

                            </div>
                            <div className="py-2 ">

                                <p className="text-small  pb-3 pt-2 text-start color-gray-1" style={{ borderBottom: '1px solid #eee' }}>{translate("Are you sure you want to remove this component?")}</p>


                                <button onClick={() => this.removeCurrentComponent()} className="py-3 px-0 w-100 flexc" style={{ borderBottom: '1px solid #eee' }}>
                                    <img className="mrd-3" src="/assets/icons/applets/general/warning.png" width="24px" />
                                    <p className="text-normal text-semibold">{translate('Remove')}</p>
                                </button>


                                <button onClick={() => this.removeConfirmModal.hideModal()} className="py-3 px-0 w-100 flexc" style={{ borderBottom: '0px solid #eee' }}>
                                    <img className="mrd-3" src="/assets/icons/useful/cancel-g.svg" width="24px" />
                                    <p className="text-normal">{translate('Cancel')}</p>
                                </button>
                            </div>

                        </div>
                    </div>
                </Modal>



                <Modal ref={el => this.configModal = el} maxWidth={500}>
                    <div className="w-100  text-center position-relative" style={{ backgroundColor: '#ffffff', borderRadius: 8, }}>


                        {/* <div className="position-absolute top-0 left-0 w-100" style={{ borderRadius: '8px 8px 0px 0px', zIndex: 2, height: 50, background: 'linear-gradient(to bottom,#CFD3EF,rgb(238,239,250))', }}>

                        </div>

                        <div className="position-absolute top-0 left-0 w-100" style={{ borderRadius: '8px 8px 0px 0px', zIndex: 0, height: 80, background: 'linear-gradient(to bottom,#CFD3EF,transparent)', }}>

                        </div> */}


                        {/* <div className="position-absolute top-0 left-0 w-100 h-100" style={{zIndex: 1, }}> 
                            <div className=" top-0 left-0 w-100" style={{ position: 'sticky',  top: 0, borderRadius: '8px 8px 0px 0px', height: 50, background: 'linear-gradient(to left,#ADE9D8,#A1F5F8)', }}>

                            </div>
                        </div> */}

                        <div className="w-100 flexcb px-4  pb-2" style={{ paddingTop: 10, zIndex: 3, position: 'sticky', top: 0, borderBottom: '0px #eee solid', background: 'linear-gradient(to left,#fff,#fff)', borderRadius: '8px 8px 0px 0px' }}>

                            <div className="text-start ">
                                {/* <p className="text-smallest mt-2 opacity-5" style={{ lineHeight: 0.5 }}>CONFIGURE</p> */}
                                <p className="text-semibold text-semibig">{checkTranslation(this.state.currentComponent?.title)}</p>
                            </div>

                            <div className="flexc" style={{ backgroundColor: '#f2f6f8' }}>
                                <button onClick={() => this.ConfigurationDone()} className=" flexc px-3 mx-1 flexcc" style={{ height: 30, background: '#ffffff50', borderRadius: 20 }}>
                                    <p className="text-normal">{translate('Done')}</p>
                                </button>

                                {/* <div className="cursor-pointer flexcc" onClick={() => this.configModal.hideModal(() => { this.removeDoneEventListener() })} style={{ width: 30, height: 30, borderRadius: '50%', backgroundColor: '#ffffff50' }}>
                                    <img style={{ width: 14, height: 14 }} src="/images/close.svg" alt="" />
                                </div> */}

                                <div className="cursor-pointer" onClick={() => this.configModal.hideModal(() => { this.removeDoneEventListener() })} style={{ width: 28, height: 28, backgroundColor: '#ffffff90', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                    <img style={{ width: 10, height: 10, opacity: 0.7 }} src="/images/close.svg" alt="" />
                                </div>

                            </div>


                        </div>




                        {/* <div className="py-3 px-3 position-relative" style={{zIndex:0}}>
                            <p className="text-small text-start color-gray-4 mb-3 px-3">{translate('Insert related information for this component. If you need help please click here.')}</p>

                            <FormViewer optionsList={this.state.optionsList} variables={variables} ref={el => this.form = el} headers={this.state.currentDiagramComponent?.headers} initData={this.state.currentHeadersData} errors={this.state.errors} inputClass={'modern-input'} liveChange={this.formLiveChange} isEditing={false} />

                        </div> */}
                    </div>

                </Modal>



                <DiagramComponentConfig ref={el => this.diagramComponentConfig = el} variables={variables} currentComponent={this.state.currentComponent} width={this.props.width} headers={this.state.currentDiagramComponent?.headers} initData={this.state.currentHeadersData} errors={this.state.errors} liveChange={this.formLiveChange} optionsList={this.state.optionsList} saveConfig={this.saveConfig} colors={this.props.colors} admins={this.state.admins} frames={this.state.frames} setAdmins={this.setAdmins} />

                <DiagramVariablesSidebar ref={el => this.diagramVariablesSidebar = el} width={this.props.width} variables={this.props.variables} colors={this.props.colors} variablesList={this.state.variablesList} />




            </div>
        )
    }


}



const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(DiagramEditor)
